// NOTE:
// ホームからshimahaku, shimameshi, shimayuへの遷移は正常に動作するが、各ページからホームへの遷移は、view-transitionしているwindowのz-indexが下になってしまう。
// ホームには、shimahaku, shimameshi, shimayuの3つのwindowがあるため、全てview-transition-groupに参加してしまい、実際にtransitionしているwindowとの区別ができない。
// それに対応するため、homeに来た際はどのページから来たのかを判別し、view-transition-nameを動的に変更することで、実際にtransitionしているwindowだけがview-transition-groupに参加するようにしている。

type NavigationWithActivation = {
  activation?: NavigationActivation | null;
};

export class ViewTransition {
  constructor() {}

  init() {
    window.addEventListener('pagereveal', async (event) => {
      if (!event.viewTransition) return;
      if (!document.body.classList.contains('home')) return;

      const currentNavigation =
        'navigation' in globalThis
          ? (
              globalThis as typeof globalThis & {
                navigation: NavigationWithActivation;
              }
            ).navigation
          : undefined;

      const fromUrl = currentNavigation?.activation?.from?.url
        ? new URL(currentNavigation.activation.from.url)
        : null;

      const serviceSlugs = new Set(['shimahaku', 'shimameshi', 'shimayu']);

      const homePathname = `${window.location.pathname.replace(/\/+$/, '')}/`;
      const fromPathname = `${(fromUrl?.pathname ?? '').replace(/\/+$/, '')}/`;

      const relativePathname = fromPathname.startsWith(homePathname)
        ? fromPathname.slice(homePathname.length)
        : fromPathname.replace(/^\/+/, '');

      const fromSlug = relativePathname.split('/').filter(Boolean)[0] ?? null;

      if (!fromSlug || !serviceSlugs.has(fromSlug)) return;

      const targets = document.querySelectorAll<HTMLElement>(
        '.wp-block-shimahaku-shimameshi-shimayu-home-virtual-window > .container-for-view-transition'
      );

      targets.forEach((element) => {
        const isTarget = element.id === `view-transition-${fromSlug}`;
        element.style.viewTransitionName = isTarget
          ? `view-transition-${fromSlug}`
          : 'none';

        // NOTE
        // headerのメニューから遷移した場合は、home-virtual-windowのjs--is-top-layerなどのz-indexの調整処理が発生せずに遷移してしまうため、戻ってきた際にz-indexが下になってしまう。
        // これを解消するため、view-transitionの開始前に、遷移元のslugと一致するidを持つ要素の親要素にjs--is-top-layerクラスを付与し、それ以外の要素からはjs--is-top-layerクラスを削除する。
        if (isTarget) {
          element.parentElement?.classList.add('js--is-top-layer');
        } else {
          element.parentElement?.classList.remove('js--is-top-layer');
        }
      });

      await event.viewTransition.ready;

      targets.forEach((element) => {
        element.style.viewTransitionName = '';
      });
    });
  }
}
